export default __webpack_public_path__ + "static/media/mobile.a10c9f0a.jpg";